// 本文件定义常用的属性
export default {
  count: state => state.app.count,
  todos: state => state.todo.todos
};
